import { Button } from '@acpaas-ui/react-components';
import { useRef, useState } from 'react';
import TextField from '../../components/forms/TextField';
import { MODALS } from '../../constants/modals.constants';
import { useModal } from '../../hooks/useModal.hook';
import overviewService from '../../services/api/overview.service';
import DeleteWarningModal from '../DeleteWarningModal';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const DeleteSchoolFromRequestModal = ({ dossierId, data, isOpen, onUpdated, onClose, dossierOverviewData }) => {
  const modalContentRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const deleteModal = useModal(MODALS.DELETE_SCHOOL_FROM_REQUEST_MODAL);

  const handleDelete = () => {
    const newBranchData = dossierOverviewData?.branch.filter((item) => item.id !== data?.branchId);
    overviewService.update(
      dossierId,
      { branch: newBranchData },
      {
        onSuccess: () => {
          setIsSubmitting(false);
          onClose();
          onUpdated('branch', newBranchData);
        },
        onError: (message) => {
          setIsSubmitting(false);
          setSubmitError(message);
        }
      }
    );
  };

  return (
    <>
      <Modal
        ref={modalContentRef}
        title={<ModalTitle title={'School'} />}
        isOpen={isOpen}
        disableConfirm
        disableCancel
        onClose={onClose}
        isSubmitting={isSubmitting}
        width={1000}
        extraFooterActions={
          <Button type="danger" outline onClick={deleteModal.onOpen}>
            Verwijderen
          </Button>
        }
      >
        <div className="row">
          {data?.school && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="School" readOnly value={data?.school} />
            </div>
          )}
          {data?.branch && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Vestiging" readOnly value={data?.branch} />
            </div>
          )}
          {data?.type && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Niveau" readOnly value={data?.type} />
            </div>
          )}
          {data?.address.trim() && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Adres" readOnly value={data?.adress} />
            </div>
          )}
          {data?.schoolPhone && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Telefoonnummer school" readOnly value={data?.schoolPhone} />
            </div>
          )}
          {data?.branchPhone && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Telefoonnummer vestiging" readOnly value={data?.branchPhone} />
            </div>
          )}
          {data?.cityDistrict && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Wijk" readOnly value={data?.cityDistrict} />
            </div>
          )}
          {data?.cityDistrictManager && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Wijkverantwoordelijke" readOnly value={data?.cityDistrictManager} />
            </div>
          )}
          {data?.director && (
            <div className="col-xs-12 col-md-6 u-margin-bottom">
              <TextField label="Directeur" readOnly value={data?.director} />
            </div>
          )}
        </div>
        {submitError && <small className="u-block u-margin-top-sm u-text-danger">{submitError}</small>}
      </Modal>
      <DeleteWarningModal
        {...deleteModal}
        warningText="Ben je zeker dat je deze school wil verwijderen?"
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DeleteSchoolFromRequestModal;
